import { Phone, Clock, MapPin, ShieldCheck, Zap } from "lucide-react";
import { COMPANY, IMAGES, buildWhatsAppLink } from "../../lib/constants";

const trustItems = [
    { icon: Clock, label: "Atendimento 24 horas" },
    { icon: Zap, label: "Chegada rápida" },
    { icon: ShieldCheck, label: "Equipe especializada" },
    { icon: MapPin, label: "Cobertura regional" },
];

export const Hero = () => {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative min-h-[88vh] md:min-h-[92vh] flex items-center overflow-hidden"
        >
            {/* Background image */}
            <div
                className="absolute inset-0 bg-cover bg-center scale-105"
                style={{ backgroundImage: `url(${IMAGES.heroBg})` }}
                aria-hidden="true"
            />
            <div className="absolute inset-0 hero-overlay" aria-hidden="true" />

            {/* Diagonal stripe accent */}
            <div className="absolute top-0 left-0 right-0 emergency-stripes h-1.5" aria-hidden="true" />

            <div className="container mx-auto px-4 md:px-8 relative z-10 py-24 md:py-32">
                <div className="max-w-4xl">
                    {/* Status pill */}
                    <div className="inline-flex items-center gap-2.5 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 mb-6 fade-up">
                        <span className="relative flex h-2.5 w-2.5">
                            <span className="absolute inline-flex h-full w-full rounded-full bg-[#f45100] opacity-75 animate-ping" />
                            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#f45100]" />
                        </span>
                        <span className="text-white text-xs md:text-sm font-bold tracking-[0.25em] uppercase">
                            Online agora · Praia Grande/SP
                        </span>
                    </div>

                    <h1
                        data-testid="hero-title"
                        className="font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black uppercase tracking-tight text-white leading-[0.95] fade-up"
                        style={{ animationDelay: "0.1s" }}
                    >
                        Guincho{" "}
                        <span className="text-[#f45100]">24 horas</span>
                        <br className="hidden sm:block" /> em Praia Grande com
                        atendimento{" "}
                        <span className="text-[#f45100]">rápido</span> e preço
                        justo
                    </h1>

                    <p
                        className="mt-6 text-base sm:text-lg md:text-xl text-white/85 max-w-2xl font-medium leading-relaxed fade-up"
                        style={{ animationDelay: "0.2s" }}
                    >
                        Atendimento imediato para carros, motos, SUVs e veículos
                        blindados. Socorro rápido 24h com total segurança em
                        toda Praia Grande e região.
                    </p>

                    {/* CTAs */}
                    <div
                        className="mt-8 flex flex-col sm:flex-row gap-3 sm:gap-4 fade-up"
                        style={{ animationDelay: "0.3s" }}
                    >
                        <a
                            href={buildWhatsAppLink()}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="hero-whatsapp-btn"
                            className="group inline-flex items-center justify-center gap-3 px-7 py-5 bg-[#25D366] hover:bg-[#1ebd5c] text-white rounded-2xl font-extrabold text-base md:text-lg shadow-2xl shadow-black/40 transition-all duration-300 hover:scale-[1.02] animate-whatsapp"
                        >
                            <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
                                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                            </svg>
                            <span>CHAMAR NO WHATSAPP</span>
                        </a>

                        <a
                            href={COMPANY.phoneTel}
                            data-testid="hero-phone-btn"
                            className="group inline-flex items-center justify-center gap-3 px-7 py-5 bg-[#f45100] hover:bg-[#d14500] text-white rounded-2xl font-extrabold text-base md:text-lg shadow-2xl shadow-[#f45100]/40 transition-all duration-300 hover:scale-[1.02] animate-siren"
                        >
                            <Phone size={22} strokeWidth={2.5} />
                            <span>LIGAR AGORA · {COMPANY.phone}</span>
                        </a>
                    </div>

                    {/* Trust indicators */}
                    <ul
                        className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 fade-up"
                        style={{ animationDelay: "0.4s" }}
                    >
                        {trustItems.map((item, i) => {
                            const Icon = item.icon;
                            return (
                                <li
                                    key={i}
                                    data-testid={`hero-trust-${i}`}
                                    className="flex items-center gap-2.5 text-white/95"
                                >
                                    <div className="flex-shrink-0 w-9 h-9 rounded-full bg-[#f45100] flex items-center justify-center">
                                        <Icon size={16} strokeWidth={2.5} />
                                    </div>
                                    <span className="text-xs md:text-sm font-bold uppercase tracking-wide">
                                        {item.label}
                                    </span>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>

            {/* Bottom marquee */}
            <div className="absolute bottom-0 left-0 right-0 bg-black/80 backdrop-blur-sm border-t border-[#f45100]/30 overflow-hidden">
                <div className="flex animate-marquee whitespace-nowrap py-3">
                    {Array.from({ length: 2 }).map((_, idx) => (
                        <div key={idx} className="flex items-center gap-12 px-6">
                            {[
                                "GUINCHO 24H PRAIA GRANDE",
                                "SOCORRO IMEDIATO",
                                "TROCA DE PNEU",
                                "RECARGA DE BATERIA",
                                "GUINCHO PARA BLINDADOS",
                                "REBOQUE RÁPIDO",
                                "AUTO SOCORRO 24H",
                                "ATENDEMOS TODA REGIÃO",
                            ].map((text, i) => (
                                <span
                                    key={i}
                                    className="flex items-center gap-3 text-xs md:text-sm font-bold uppercase tracking-[0.2em] text-white"
                                >
                                    <span className="w-1.5 h-1.5 rounded-full bg-[#f45100]" />
                                    {text}
                                </span>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
